// src/Contact.jsx
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PageWrapper from './components/PageWrapper';
import ContactBg from './assets/things/ContactBg.jpg';
import { signIn } from './data/adminApi';

const rows = [
  {
    title: 'Email us',
    text: 'Questions or inquiries? Reach out and we will get back to you shortly.',
    cta: 'Send an email',
    href: 'mailto:info@primefleetholdings.com',
    detail: 'info@primefleetholdings.com',
  },
  {
    title: 'Rent a car',
    text: 'See the full fleet and check availability on Turo.',
    cta: 'Visit our Turo profile',
    href: 'https://turo.com/us/en/drivers/33571187',
    external: true,
  },
  {
    title: 'Have a car to manage?',
    text: 'Tell us about your vehicle and we will send you terms.',
    cta: 'Apply for management',
    to: '/fleet-management',
  },
];

export default function Contact() {
  return (
    <PageWrapper backgroundImage={ContactBg}>
      <div className="container-x" style={{ maxWidth: '48rem' }}>
        <h1 className="display text-4xl sm:text-5xl">Get in touch</h1>

        <ul className="mt-8" style={{ borderTop: '1px solid var(--line)' }}>
          {rows.map((row) => (
            <li
              key={row.title}
              className="flex flex-col gap-4 py-6 sm:flex-row sm:items-center sm:justify-between"
              style={{ borderBottom: '1px solid var(--line)' }}
            >
              <div>
                <h2 className="display text-xl">{row.title}</h2>
                <p className="muted mt-1 max-w-md">{row.text}</p>
                {row.detail && <p className="mt-1 font-medium">{row.detail}</p>}
              </div>
              {row.to ? (
                <Link to={row.to} className="btn btn-primary shrink-0">
                  {row.cta}
                </Link>
              ) : (
                <a
                  href={row.href}
                  className="btn btn-primary shrink-0"
                  {...(row.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                >
                  {row.cta}
                </a>
              )}
            </li>
          ))}
        </ul>

        <p className="muted mt-8 text-sm">Prime Fleet Holdings LLC, Las Vegas, Nevada</p>

        <AdminSignIn />
      </div>
    </PageWrapper>
  );
}

function AdminSignIn() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await signIn(password);
      navigate('/admin');
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit} className="mt-16 pt-6" style={{ borderTop: '1px solid var(--line)' }}>
      <label htmlFor="admin-password" className="field-label">
        Owner sign in
      </label>
      <div className="flex max-w-sm gap-2">
        <input
          id="admin-password"
          type="password"
          inputMode="numeric"
          autoComplete="current-password"
          className="field"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" className="btn btn-ghost shrink-0" disabled={busy}>
          {busy ? 'Checking' : 'Sign in'}
        </button>
      </div>
      {error && (
        <p role="alert" className="mt-2 text-sm" style={{ color: '#f0a08a' }}>
          {error}
        </p>
      )}
    </form>
  );
}
